module.exports = __webpack_public_path__ + "img/7.f59543a6.jpg";